import { render, staticRenderFns } from "./ZhanhuiMjStatBlock.vue?vue&type=template&id=5fabe407&scoped=true"
import script from "./ZhanhuiMjStatBlock.vue?vue&type=script&lang=js"
export * from "./ZhanhuiMjStatBlock.vue?vue&type=script&lang=js"
import style0 from "./ZhanhuiMjStatBlock.vue?vue&type=style&index=0&id=5fabe407&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5fabe407",
  null
  
)

export default component.exports